import React from "react";
import Layout from "../../layouts/Layout";

import apiService from '../../utils/api.service';
import moment from "moment";
import Lineliff from '../../components/LineLiff';
import { connect } from "react-redux";
import actions from "../../redux/actions";
import helper from "../../utils/helper"
import { useNavigate, useSearchParams } from "react-router-dom";
import BButton from "../../components/general/BButton";
import CanNotCheckIn from "../../components/icons/CanNotCheckIn";
import History from "../../components/icons/History";
import SlideBottomPage from "./SlideBottomPage";
import _, { filter } from "lodash"
import haversine from 'haversine-distance'
import { Link } from "react-router-dom";
import ErrorLocation from "./ErrorLocation"
import ConfrimWorkInOut from "./ConfrimWorkInOut"

class CheckIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: null,
      isShow: false,
      // currentDate: "2022-12-01" || moment().format('YYYY-MM-DD'),
      currentDate: moment().format('YYYY-MM-DD'),
      checkInData: [],
      popupData: {},
      isErrorLocation: true,
      isConfirmWorkIn: false,
      isConfirmWorkOut: false,
      payloadWorkInOut: {},
      location: { latitude: null, longitude: null, err: false },
      remark: '',
      isLoading: false,
      checkLocation: false,



      error: {},
      fileUploadError: false,
      fileUpload: null,
      filename: "",
      refreshFile: false,
      imageErr: false,


    };
    this.bottomPage = React.createRef()
    this.cbLineLiff = this.cbLineLiff.bind(this)
    this.toDay = this.toDay.bind(this)
    this.gotoHistory = this.gotoHistory.bind(this)
    this.onCreateEndorseTime = this.onCreateEndorseTime.bind(this)
    this.getLocation = this.getLocation.bind(this)
    this.showPosition = this.showPosition.bind(this)
    this.showError = this.showError.bind(this)


    this.uploadFile = this.uploadFile.bind(this);
    this.uploadClear = this.uploadClear.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.getBase64 = this.getBase64.bind(this);
  }
  componentDidMount() {
    this.LoadCheckIn()
    this.getLocation()
    this.getConfig()
  }

  getLocation() {
    if (navigator.geolocation) {
      console.log('GET LO 1')
      var options = {
        enableHighAccuracy: true,
        timeout: 3000,
        maximumAge: 0
      };
      navigator.geolocation.getCurrentPosition(this.showPosition, this.showError, options);
    }
  }

  showPosition(position) {
    console.log("Latitude: " + position.coords.latitude + "Longitude: " + position.coords.longitude)
    const payload = { latitude: position.coords.latitude, longitude: position.coords.longitude, err: false }
    console.log('payload showPosition >>', payload)
    this.setState({ location: payload })
    console.log('payload SS')
  }

  showError(position) {
    // alert('showError')
    const payload = { latitude: null, longitude: null, err: true }
    console.log('payload  showError >>', payload)
    this.setState({ location: payload })
    console.log('payload EE')
  }

  async LoadCheckIn() {
    try {
      const memberId = this.props?.user?.lineId?.memberId
      const { currentDate } = this.state
      const payload = { memberId: memberId, date: currentDate }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CheckIn.SearchTimeRecord(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        let testData = [
          {
            workShiftSchedule: {
              date: "2022-12-13T00:00:00.000Z",
              shiftTimeFrom: "12:00:00",
              shiftTimeTo: "18:00:00",
            },
            timeRecord: {
              workIn: "14:00:00",
              workOut: "20:00:00",
            },
          },
          {
            workShiftSchedule: {
              date: "2022-12-11T00:00:00.000Z",
              shiftTimeFrom: "12:00:00",
              shiftTimeTo: "18:00:00",
            },
            timeRecord: {
              workIn: "12:00:00",
              workOut: "18:00:00",
            }
          },
          {
            workShiftSchedule: {
              date: "2022-12-12T00:00:00.000Z",
              shiftTimeFrom: "12:00:00",
              shiftTimeTo: "18:00:00",
            },
            timeRecord: {
              workIn: "13:00:00",
              workOut: "19:00:00",
            }
          },
        ]
        const ans = this.toCheckInList(data, currentDate)
        console.log('ans >>', ans)
        // console.log('data >>', data)
        this.setState({ checkInData: ans })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  calDistance() {
    const a = { latitude: 37.8136, longitude: 144.9631 }
    const b = { latitude: 33.8650, longitude: 151.2094 }
    console.log('distance >>',haversine(a, b)) 
  }

  cbLineLiff (e) {
    this.setState({ memberId: e.memberId }, () => this.LoadCheckIn())
  }
  toDay(date) {
    const DD = moment(date).format('DD')
    const M = helper.CONFIG.MONTH[moment(date).format('M')]
    const YYYY = moment(date).format('YYYY')
    return `${DD} ${M} ${YYYY}`
  }
  TimeCheckIn(time, type = 1, noRec = true) {
    if(noRec) {
      return <div>..........</div>
    }
    if(type === 2 && !!time === false) {
      return <div>Now</div>
    }
    return <div>{helper.FN.toTimeHM(time)} น.</div>
  }

  async onWorkIn(item) {
    console.log('onWorkIn!')
    const curLocation = this.state.location
    this.setState({ isLoading: true })
    try {
      const memberId = this.props?.user?.lineId?.memberId
      const { currentDate } = this.state
      const payload = {
        timeRecordId: null,
        bookingWorkId: item.bookingWorkId,
        memberId: memberId,
        date: currentDate,
        workIn: moment().format('HH:mm'),
        workOut: "",
        wardId: `${item.workShiftSchedule?.ward?.wardId}`,
        shift: item.workShiftSchedule?.shift,
        shiftTimeFrom: helper.FN.toTimeHMC(item.workShiftSchedule?.shiftTimeFrom),
        shiftTimeTo: helper.FN.toTimeHMC(item.workShiftSchedule?.shiftTimeTo),
        isInLocationIn: item.isInLocationIn,
        // isInLocationOut: false,
        latLongIn: curLocation.latitude + ', ' + curLocation.longitude,
        // latLongOut: '13.812, 100.5948'
        fileUpload: this.state.fileUpload
      }
      console.log('payload item >>', item)
      console.log('payload >>', payload)
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CheckIn.CreateTimeRecord(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        this.setState({ isConfirmWorkIn: false })
        this.LoadCheckIn()
      }
      this.setState({ isLoading: false })
    }
    catch(e){
      console.log('API ERR', e)
      this.setState({ isLoading: false })
    }
  }
  async onWorkOut(item) {
    console.log('onWorkOut!')
    this.setState({ isLoading: true })
    try {
      const memberId = this.props?.user?.lineId?.memberId
      const curLocation = this.state.location
      const { currentDate } = this.state
      const payload = {
        timeRecordId: Number(item.timeRecord?.timeRecordId),
        // memberId: memberId,
        workDateIn: moment(item.workShiftSchedule?.date).format('YYYY-MM-DD'),
        workDateOut: currentDate,
        workIn: helper.FN.toTimeHMC(item.timeRecord?.workIn),
        workOut: moment().format('HH:mm'),
        // wardId: `${item.workShiftSchedule?.wardId}`,
        shiftTimeFrom: helper.FN.toTimeHMC(item.workShiftSchedule?.shiftTimeFrom),
        shiftTimeTo: helper.FN.toTimeHMC(item.workShiftSchedule?.shiftTimeTo),
        // isInLocationIn: item.isInLocationIn,
        isInLocationOut: item.isInLocationOut,
        // latLongIn: '13.812, 100.5948',
        latLongOut: curLocation.latitude + ', ' + curLocation.longitude,
        fileUpload: this.state.fileUpload
      }
      console.log('payload item >>', item)
      console.log('payload >>', payload)
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CheckIn.CreateTimeRecord(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        this.setState({ isConfirmWorkOut: false })
        this.LoadCheckIn()
      }
      this.setState({ isLoading: false })
    }
    catch(e){
      console.log('API ERR', e)
      this.setState({ isLoading: false })
    }
  }

  toCheckInList(checkInList = [], currentDate) {
    let checkIn = _.cloneDeep(checkInList)
    checkIn.sort((a,b) => helper.SORT.compare(a, b , 'workShiftSchedule.date'))
    console.log('ci.toCheckInList checkIn SORT ------>>', checkIn)
    const lenArr = checkIn.length - 1
    let ans = []
    for(const i in checkIn) {
      const ci = checkIn[i]
      console.log('ci.timeRecord >>', i)
      console.log('ci.timeRecord x>>', lenArr)
      console.log('ci.timeRecord.workIn >>', ci.timeRecord.workIn)
      console.log('ci.timeRecord.workOut >>', ci.timeRecord.workOut)
      if(i == lenArr)  {
        console.log('ci.bbbb')
        ans.push(ci)
      }
      else if (ci.timeRecord.workIn === null && ci.timeRecord.workOut === null) {
        console.log('ci.aaaa')
        ans.push(ci)
      }
      else if (!!ci.timeRecord.workIn && ci.timeRecord.workOut === null) {
        console.log('ci.ccc')
        ans.push(ci)
      }
      console.log('workShiftSchedule >>', ci.workShiftSchedule.date)
      console.log('currentDate >>', currentDate)
      console.log('ci.---------------------')
    }
    console.log('ans >>', ans)
    ans = ans.filter(item => (item.timeRecord.workIn && item.timeRecord.workOut === null ) || moment(item.workShiftSchedule?.date).format('YYYY-MM-DD') == moment(currentDate).format('YYYY-MM-DD'))
    return ans
  }

  async onCreateEndorseTime(remark) {
    console.log('onCreateEndorseTime remark >>', remark)
    try {
      const { popupData, } = this.state
      const payload = {
        // popupData: popupData,
        "timeRecordId": popupData.timeRecord?.timeRecordId,
        "endorseWorkIn": helper.FN.toTimeHMC(popupData.workShiftSchedule?.shiftTimeFrom),
        "endorseWorkOut": helper.FN.toTimeHMC(popupData.workShiftSchedule?.shiftTimeTo),
        "reason": remark
      }
      // console.log('payload item >>', item)
      console.log('payload >>', payload)
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.CheckIn.CreateEndorseTime(payload, header)
      if (resData.resultCode === "20000") {
        const data = _.cloneDeep(resData.data)
        console.log('data >>', data)
        console.log('this.bottomPage >>', )
        this.bottomPage.current?.onClear()
        this.setState({ popupData: {}, isShow: false }, ()=> this.LoadCheckIn())
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }
  gotoHistory() {
    this.props.navigate('/history-check-in')
  }

  isCanWork (LocationA = { latitude: 0, longitude: 0 }, LocationB = { latitude: 0, longitude: 0 }) {
    
    const a = { latitude: 37.8136, longitude: 144.9631 }
    const b = { latitude: 33.8650, longitude: 151.2094 }
    console.log('isCanWork distance x>>',haversine(a, b)) 

    console.log('isCanWork LocationA >>', LocationA) 
    console.log('isCanWork LocationB >>', LocationB) 
    const scope = 1000
    const distance = haversine(LocationA, LocationB)
    console.log('isCanWork distance >>', distance) 
    // return false 
    if(scope >= distance) {
      return false
    }
    return true
  }

  workJobByConfig(conf = true, value) {
    if (conf) {
      return value
    }
    return true
  }

  async getConfig() {
    try {
      const { resData } = await apiService.Profile.SearchConfig()
      if (resData.resultCode === "20000") {
        console.log('resData getConfig >> ', resData.resultData)
        this.setState({ checkLocation: resData.resultData.CHECK_LOCATION }) 
      }
    }
    catch(e){
      console.log('API ERR getConfig', e)
    }
  }

  getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const fileUpload = reader.result;
      this.setState({ imageErr: false, fileUpload: fileUpload, filename: file.name });
    };
    reader.onerror = (error) => {
      console.log("Error: ", error);
    };
  }

  uploadFile(e){
    console.log(e.target.files[0]);
    let file = e.target.files[0]
    console.log('file >>', file)
    const MAXSIZEFILE = helper.CONFIG.MAXSIZEFILE
    const IMGTYPEFILE = helper.CONFIG.IMGTYPEFILE
    console.log("MAXSIZEFILE", MAXSIZEFILE);
    if (IMGTYPEFILE.includes(file.type) && file.size <= MAXSIZEFILE) {
      this.getBase64(file)
    } else {
      this.setState({ imageErr: true });
    }
  }

  uploadClear() {
    this.setState({ fileUpload: null, filename: "", refreshFile: true });
    setTimeout(() => this.setState({ refreshFile: false }), 50);
  }

  uploadImage(notImage = false) {
    if (notImage) {
      document.getElementById("uploadImage").click();
    }
  }

  render() {
    const test = 2
    const { currentDate, isShow,  } = this.state
    const { checkInData, popupData } = this.state
    const { isErrorLocation } = this.state
    const { isConfirmWorkIn, isConfirmWorkOut } = this.state
    const { payloadWorkInOut } = this.state
    const curLocation = this.state.location
    const notGetLocation = this.state?.location?.err || false 


    const { fileUpload, error, refreshFile, imageErr } = this.state;
   
    return (
      <>
        <Layout>
          <div className="container-checkin">
            <div className="header">
              <div className="main-header-text">บันทึกเข้า - ออก</div>
              {/* {JSON.stringify(this.state.location)} */}
              {/* {JSON.stringify(curLocation)} <br/> */}
              {/* ------------------ */}
            </div>
            <main>
              { 
                checkInData.length === 0 && 
                <div className="not-schedule">
                  <div className="history" onClick={this.gotoHistory}>
                    <History/>
                  </div>
                  <div className="icon">
                    <CanNotCheckIn/>
                  </div>
                  <div className="date-now">
                    {this.toDay(currentDate)}
                  </div>
                  <BButton setStyle="block shadow" disable={true}>คุณไม่มีกะทำงานในวันนี้</BButton>
                </div>
              }
              { 
                checkInData.length > 0 && 
                checkInData.map(( item, index ) => {
                const workInLocation = { latitude: Number(item.workShiftSchedule?.ward?.hospital?.lat) || 0, longitude: Number(item.workShiftSchedule?.ward?.hospital?.long) || 0 }
                

                // const now = moment().format("16:59:00")
                console.log("item bookingWorkId :", item.bookingWorkId)
                console.log("item workShiftSchedule :", item.workShiftSchedule)
                const workDate = moment(item.workShiftSchedule.date).format('YYYY-MM-DDT')
                const now = moment().format("YYYY-MM-DDTHH:mm:ss")
                const workIn = workDate + item.workShiftSchedule?.shiftTimeFrom
                const workIn_20 = moment(workIn,"YYYY-MM-DDTHH:mm:ss").add(-2,'hour').format("YYYY-MM-DDTHH:mm:ss")
                const calDiff = moment(now, "YYYY-MM-DDTHH:mm:ss").diff(moment(workIn_20, "YYYY-MM-DDTHH:mm:ss"),'minute')
                const isWorkIn = calDiff >= 0

                console.log("_workIn_now:", now)
                console.log("_workIn_20:", workIn_20)
                // console.log("workIn: ans", ans)
                console.log("_workIn_calDiff:", calDiff)
                console.log("_workIn: isWorkIn", isWorkIn)
                console.log("_workIn: -----------------------")
                
                console.log('===============_workOutA ====================')
                let isWorkOut = false
                console.log('item.timeRecord?.workIn >>', item.timeRecord?.workIn)
                if (item.timeRecord?.workIn) {
                  const timeWorkIn = workDate + item.timeRecord?.workIn
                  const timeWorkIn_Add_30 = moment(timeWorkIn,"YYYY-MM-DDTHH:mm:ss").add(30,'minute').format("YYYY-MM-DDTHH:mm:ss")
                  const calDiff2 = moment(now, "YYYY-MM-DDTHH:mm:ss").diff(moment(timeWorkIn_Add_30, "YYYY-MM-DDTHH:mm:ss"),'minute')
                  isWorkOut = calDiff2 >= 0
                  
                  console.log("_workOut_now:", now)
                  console.log("_workOut_timeWorkIn:", timeWorkIn)
                  console.log("_workOut_Add_30 :", timeWorkIn_Add_30)
                  console.log("_workOut_calDiff2:", calDiff2)
                  console.log("_workOut_isWorkOut:", isWorkOut)

                  console.log("_workOut: -----------------------")
                }
                console.log('===============_workOut B====================')

                // Switch Config Location
                const isCanWork = this.isCanWork(curLocation, workInLocation) === false // ลงชื่อตาม GPS
                const isWorkJobLocaiton = this.workJobByConfig(this.state.checkLocation, isCanWork) // ลงชื่อตาม CONFIG
                let isCheckFile_Location = false
                if (isWorkJobLocaiton === false) {
                  isCheckFile_Location = fileUpload !== null
                }
                if (index == 0) {
                  return(
                    <div key={index}>
                      <div className="checkin-schedule">
                        <div className="history" onClick={this.gotoHistory}>
                          <History/>
                        </div>
                        <div className="icon">
                          <CanNotCheckIn/>
                        </div>
                        <div className="date-now"> 
                          {this.toDay(currentDate)}
                        </div>
                        <div className="date-now-info">
                          {helper.FN.numberToshift(item.workShiftSchedule?.shift)} ({helper.FN.toTimeHM(item.workShiftSchedule?.shiftTimeFrom)} - {helper.FN.toTimeHM(item.workShiftSchedule?.shiftTimeTo)}) วันที่ { this.toDay(item.workShiftSchedule?.date)}
                        </div>
                        <BButton setStyle="block shadow">
                          <div className="checkin-btn">
                            {this.TimeCheckIn(item.timeRecord?.workIn, 1, !item.timeRecord?.workIn)}
                            <div>-</div>
                            {this.TimeCheckIn(item.timeRecord?.workOut, 2, !item.timeRecord?.workIn)}
                          </div>
                        </BButton>
                        <div style={{ }}>
                          { 
                            !curLocation.latitude && this.state.checkLocation
                            ? <div style={{ marginTop:"30px", color: '#C33232', fontSize: "16px" }}>ไม่พบตำแหน่ง กรุณาเปิดการใช้งานตำแหน่งของคุณ</div>
                            : !isWorkIn  
                            ? (
                              <div style={{ marginTop:"30px", color: '#C33232', fontSize: "16px" }}>
                                <p style={{ marginBottom:"6px" }}>ไม่สามารถเข้างานได้ เนื่องจากยังไม่ถึงเวลาเข้างาน</p>
                                <p style={{ marginBottom:"0px" }}>(สามารถเข้างานได้ไม่เกิน 2 ชั่วโมงก่อนเวลาเข้างาน)</p> 
                              </div>
                            )
                            : <></>
                          }
                         
                        </div>
                      </div>
                      {/* {JSON.stringify(workInLocation)} */}

                      { item.timeRecord?.workIn  && item.timeRecord?.workOut 
                        ? <></>
                        : <div className="checkin-footer">
                          {
                              item.timeRecord?.workIn ? (
                                <>
                                  <BButton
                                    setStyle="outline block"
                                    // disable={isWorkJobLocaiton === false || !isWorkOut} อันเก่า
                                    disable={ !( isWorkOut === true && (isWorkJobLocaiton === true || isCheckFile_Location === true))}
                                    onClick={() =>
                                      this.setState({
                                        isConfirmWorkOut: true,
                                        payloadWorkInOut: {
                                          ...item,
                                          isInLocationOut: isCanWork,
                                        },
                                      })
                                    }
                                  >
                                    ออกงาน
                                  </BButton>
                                </>
                              ) : (
                                <BButton
                                  setStyle="outline block"
                                  // disable={isWorkJobLocaiton === false || !isWorkIn} อันเก่า
                                  disable={ !( isWorkIn === true && (isWorkJobLocaiton === true || isCheckFile_Location === true))}
                                  onClick={() =>
                                    this.setState({
                                      isConfirmWorkIn: true,
                                      payloadWorkInOut: {
                                        ...item,
                                        isInLocationIn: isCanWork,
                                      },
                                    })
                                  }
                                >
                                  เข้างาน
                                </BButton>
                              )
                            }
                            {/* <div>isWorkJobLocaiton { isWorkJobLocaiton ? 'true' : 'false' }</div>
                            <div>isWorkIn { isWorkIn ? 'true' : 'false' }</div>
                            <div>isWorkOut { isWorkOut ? 'true' : 'false' }</div>
                            <div>fileUpload {fileUpload !== null ? 'true' : 'false'}</div>
                            <div>{JSON.stringify(curLocation)}</div> */}
                            {
                              !curLocation.latitude && this.state.checkLocation && (
                                <div className="upload-container">
                                  {fileUpload === null ? (
                                    <>
                                      <div className=""
                                        onClick={this.uploadImage}
                                      >
                                        <BButton setStyle="outline block">
                                          แนบรูปหลักฐาน
                                        </BButton>
                                      </div>
                                      { 
                                        imageErr &&
                                        <div className="err-img">
                                          <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                                          <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                                        </div>
                                      }
                                    </>
                                  ) : (
                                    <div>
                                        <div
                                          className="icon-clear"
                                          style={{ position: 'relative' }}
                                          onClick={this.uploadClear}
                                        >
                                          <BButton setStyle="outline block" >
                                          ยกเลิก แนบรูปหลักฐาน
                                          </BButton>
                                      </div>
                                      { 
                                        imageErr &&
                                        <div className="err-img">
                                          <div>สามารถอัพโหลดไฟล์ .jpg .jpeg .png เท่านั้น</div>
                                          <div>ขนาดไฟล์ไม่เกิน 1 MB</div>
                                        </div>
                                      }
                                    </div>
                                  )}
                                </div>
                              )
                            }
                          {/* <BButton setStyle="block" onClick={(e)=> this.setState({ isShow: true, popupData: item })}> ขออนุมัติเวลา </BButton> */}
                        </div>
                      }
                    </div>
                  )}
                })
              }
              { false &&<SlideBottomPage ref={this.bottomPage} isShow={isShow} setIsShow={(e)=> this.setState({ isShow:e, popupData: {} })} slideData={popupData} currentDate={currentDate} onConfirm={(e) => this.onCreateEndorseTime(e)}/> }
            {/* {this.state.checkLocation+''} */}
            </main>
          </div>
        </Layout>
        
        <ErrorLocation isModalOpen={ notGetLocation && isErrorLocation} onOK={() => this.setState({ isErrorLocation: false })}/>

        {/* เข้างาน */}
        <ConfrimWorkInOut 
          type={'WORKIN'} 
          workInOutData={payloadWorkInOut} 
          isModalOpen={ isConfirmWorkIn } 
          onOK={() => this.onWorkIn(payloadWorkInOut)} 
          onCancel={() => { this.setState({ isConfirmWorkIn: false }) }}
          isLoading={this.state.isLoading}
        />
        
        {/* ออกงาน */}
        <ConfrimWorkInOut 
          type={'WORKOUT'} workInOutData={payloadWorkInOut} 
          isModalOpen={ isConfirmWorkOut } 
          onOK={() => this.onWorkOut(payloadWorkInOut)} 
          onCancel={() => { this.setState({ isConfirmWorkOut: false }) }} 
          isLoading={this.state.isLoading}
        />

      
      {
        refreshFile === false ? (
          <>
            <input
              id="uploadImage"
              accept="image/*"
              type="file"
              onChange={this.uploadFile}
            />
          </>
        ) : (
          <>
          </>
        )
      }
      </>
    );
  }
}

function CheckInRoute(props) {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return <CheckIn navigate={navigate} searchParams={searchParams} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(CheckInRoute);